import React, { useEffect, useState } from "react";
import { Container, Hero, HeroBody } from 'bloomer'
import styled from 'styled-components'

import Layout from '../components/layout'
import { RouteDemoVideoMetadata } from '../content/videos'


const SignUpLink = styled.a`
  background-color: ${({disabled}) => disabled ? '#0b64e94d' : '#0b64e9' };
  align-items: center;
  border-radius: 4px;
  box-shadow: none;
  color: white !important;
  cursor: pointer;
  ${({disabled}) => disabled ? 'pointer-events: none;' : ''}
  display: inline-flex;
  font-size: 1rem;
  height: 2.5rem;
  justify-content: center;
  line-height: 1.5;
  padding-bottom: calc(0.375rem - 1px);
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: calc(0.375rem - 1px);
  position: relative;
  text-align: center;
  transition: transform 0.4s ease;
  user-select: none;
  vertical-align: top;
  white-space: nowrap;
  width: 144px;

  :active,
  :focus,
  :hover {
    background-color: #0061e4;
    color: white !important;
    transform: translateY(-4px);
  }

  @media only screen and (min-width: 45rem) {
    font-size: 1.25rem;
    height: 3rem;
    padding: 1rem;
    width: 12rem;
  }
`

const MessageAboveButton = styled.p`
  color: #0b64e9;
  font-size: 1.1rem;
  font-weight: 500;
  margin-bottom: 0;
  margin-top: 1.5rem;
  text-align: center;
`


const SignUp = ({ style, disabled }) => (
  <SignUpLink disabled={disabled} href={"https://app.getroute.com/signup"} rel="noopener noreferrer" style={style} target="_blank">
    Sign Up Now
  </SignUpLink>
)

const defaultSignUpStyle = { marginTop: '0.5rem' }

const SignUpVideo = () => {
  const isBrowser = typeof window !== "undefined"
  
  let player
  let tag
  let firstScriptTag
  const [videoDone, setVideoDone] = useState(false)

  useEffect(() => {
    const setPlayer = setInterval(() => {
      const checkYoutube = onYouTubeIframeAPIReady()
      if (checkYoutube) {
        clearInterval(setPlayer)
        const timeCheck = setInterval(() => {
          const currentTime = player?.playerInfo?.currentTime
          if (currentTime > 180) {
            setVideoDone(true)
            clearInterval(timeCheck)
          }
        }, 3000)
      }
    }, 500)
    return () => clearInterval(setPlayer)
  }, [player])

  if (!isBrowser) return null

  if (window && window.document) {
    tag = window.document.createElement('script')
    tag.id = 'yt-iframe'
    tag.src = 'https://www.youtube.com/iframe_api'

    firstScriptTag = window.document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
  }

  function onYouTubeIframeAPIReady() {
    if (!isBrowser) return null
    let YT
    if (window?.YT) {
      YT = window?.YT
    }

    if (YT) {
      YT.ready(() => {
        player = new YT.Player('signup-video', {
          onReady: onPlayerReady
        })
        
      })
      return true
    }

    return false
  }

  function onPlayerReady(event) {
    event.target.playVideo()
  }
  console.log('video done: ', videoDone)
  return(
    <Layout>
      <Hero isColor={'light'}>
      <HeroBody>
        <Container hasTextAlign={`centered`}>
        <div className="vid-container">
          <iframe
            id={`signup-video`}
            src={`${RouteDemoVideoMetadata.src}?enablejsapi=1&autoplay=1&disablekb=1&controls=0`}
            allowFullScreen
            origin={`getroute.com`}
            className={`youtube video-player`}
            allow={`accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture`}
            referrerPolicy={`no-referrer-when-downgrade`}
            height={405}
            width={720}
          />
          {player}
          {onYouTubeIframeAPIReady()}
        </div>
        <MessageAboveButton>
          {videoDone ? 'Ready to get started?' : 'Button will be available when video is finished'}
        </MessageAboveButton>
        <SignUp style={defaultSignUpStyle} disabled={!videoDone} />
      </Container>
      </HeroBody>
      </Hero>
    </Layout>
  )
}

export default SignUpVideo